import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-auth-redirect',
  standalone: true,
  template: '',
})
export class AuthRedirectComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly msalBroadcastService = inject(MsalBroadcastService);

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        take(1)
      )
      .subscribe(() => {
        void this.router.navigateByUrl('/schedule/vehicle');
      });
  }
}
